module.exports = __webpack_public_path__ + "img/undraw_content_team_3epn.2472a077.svg";